export const environment = {
  production: true,
  mock: false,
  backendBaseURL: location.origin + '/api',
  posApiURL: 'https://tpv.ceca.es/tpvweb/tpv/compra.action',
};
